import { Injectable } from '@angular/core';
/*
  Generated class for the ConfigurationData provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ConfigurationDataProvider {
  
  public apiURL = "https://api.pepe-4u.de/";
  public loginURL = this.apiURL+"/user/login";
  public moduleURL = this.apiURL+"module/";
  public articleURL = "https://api.pepe-4u.de/article/";
  public vendorURL = "https://api.pepe-4u.de/vendor/";
  public receiptURL = "https://api.pepe-4u.de/receipt/";
  public customerURL = "https://api.pepe-4u.de/customer/";
  public orderURL = "https://api.pepe-4u.de/order/";
  public areaURL = "https://api.pepe-4u.de/area/";
  public locationTypeURL = "https://api.pepe-4u.de/locationType/";
  public locationURL = "https://api.pepe-4u.de/location/";
  public binURL = "https://api.pepe-4u.de/bin/";
  public bintypeURL = "https://api.pepe-4u.de/bintype/";
  public stockURL = "https://api.pepe-4u.de/stock/";
  public locationSearchURL = "https://api.pepe-4u.de/lss/";
  public taskSearchURL = "https://api.pepe-4u.de/tss/";
  public taskURL = "https://api.pepe-4u.de/task/";
  public stockSearchURL = "https://api.pepe-4u.de/stockSearch/";
  public stockSearchTaskURL = "http://api.pepe-4u.de/sss";

 /* public apiURL = "http://localhost:8080/";
  public loginURL = this.apiURL+"/user/login";
  public moduleURL = this.apiURL+"module/";
  public articleURL = "http://localhost:8081/article/";
  public vendorURL = "http://localhost:8082/vendor/";
  public receiptURL = "http://localhost:8082/receipt/";
  public customerURL = "http://localhost:8083/customer/";
  public orderURL = "http://localhost:8083/order/";
  public areaURL = "http://localhost:8084/area/";
  public locationTypeURL = "http://localhost:8084/locationType/";
  public locationURL = "http://localhost:8084/location/";
  public binURL = "http://localhost:8084/bin/";
  public bintypeURL = "http://localhost:8084/bintype/";
  public stockURL = "http://localhost:8085/stock/";
  public locationSearchURL = "http://localhost:8084/locationSearch/";
  public taskURL = "http://localhost:8087/task/";
  public taskSearchURL = "http://localhost:8087/taskSearch/";
  public stockSearchURL = "http://localhost:8085/stockSearch/";
  public stockSearchTaskURL = "http://localhost:8089/sss";
*/


  public modIdReceipt = 1002;
  public modIdTasks = 1001;
  public modIdOrder = 1003;
  public modIdInventory = 1004;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/providers/configuration-data-provider.ts